import { FONT_FAMILY_PRIMARY } from '../constants/fonts';

/**
 * JLL Branding Configuration
 * Centralized branding and styling for Survey AI Analytics
 */

const branding = {
  colors: {
    primary: '#000000', // Black
    secondary: '#FFFFFF', // White
    accent: '#09ad40', // JLL Green
    background: '#f5f5f5',
    text: {
      primary: '#000000',
      secondary: '#666666',
    },
  },

  fonts: {
    primary: FONT_FAMILY_PRIMARY,
    secondary: FONT_FAMILY_PRIMARY,
  },

  button: {
    variant: 'contained',
    size: 'medium',
    sx: {
      backgroundColor: '#000000',
      color: '#FFFFFF',
      borderRadius: '1.25rem',
      textTransform: 'none',
      padding: '0.625rem 1.5rem',
      '&:hover': {
        backgroundColor: '#333333',
      },
      '&.Mui-disabled': {
        backgroundColor: 'rgba(0,0,0,0.12)',
        color: 'rgba(0,0,0,0.38)',
      },
    },
    style: {
      backgroundColor: '#000000',
      color: '#FFFFFF',
      borderRadius: '1.25rem',
      textTransform: 'none',
      padding: '0.625rem 1.5rem',
    },
  },

  icon: {
    style: {
      fontSize: '1.5625rem',
      color: 'black',
    },
  },

  dialog: {
    PaperProps: {
      sx: {
        borderRadius: '24px',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(14px)',
        boxShadow: '0 10px 40px rgba(0,0,0,0.25)',
      },
    },
  },
};

export default branding;





